const constructSingleAlbumViewInfo = (response,coverImage) => {
    
    let albumDescription = photoOrg.assetUtils.getValue(response.entities[0].userTags, 'description');        
    let assetsLength = response.entities[0].assetIdList.length;
    let albumCaption = photoOrg.assetUtils.getValue(response.entities[0].userTags, 'caption');        
    coverImage = photoOrg.assetUtils.getCoverImageUrl(coverImage,photoOrg.assetUtils.getCoverImageDimension());
    
    let context = {
        albumId : response.entities[0].id,
        caption: albumCaption,
        assets: assetsLength + ' ' + photoOrg.photoLib.getAssetText(assetsLength),
        cover_photo_url: coverImage,
        album_description: albumDescription,
        accessType: photoOrg.photoLib.accessType.guest,
        sharedByMe: false,
        hideBrowsAlbums: false,
        isPicker:false,
        hideLikeButton:true,
        hideSortOrder:true,
        photosCount:assetsLength,
        imageHeight : photoOrg.assetUtils.getThumbnailDimension(screen.width),
        createDate: moment(response.entities[0].createDate).format(photoOrg.config.date_format),
        hideUploadButton:true,
        ownedAlbumView:false,
        sharedWithMeText:"",
        photoTitleChecked :false,
        shared:true,
        ownerName:"",
        showCaption: (albumDescription.length > 0)?true:false,
        showExpressPrintsIcon: false,
        sourceClass: "",
        isHostSource: true
    };
    return context;        
}


export const processSingleAlbumInfoByTokenResponse = (response) => {        
    console.log("in processSingleAlbumInfoByTokenResponse...starts"); 
    if (response.resultCount <= photoOrg.photoLib.limit) {
        photoOrg.photoLib.isSingleAlbumAssetsLoaded = true;            
    }

    var isShared = false;
    const res=response.entities[0].systemTags;
    console.log(res);
    res.forEach(function(val) {
        if ((val.key == "Share" && val.value == "Public")||(val.key == "Share" && val.value == "Private")) {
            isShared = true;
        }  
    })

    photoOrg.photoLib.totalAssetCount = response.entities[0].assetIdList.length;
    
    let coverImage = photoOrg.Util.getThumbnailURL(response.entities[0].firstAssetId.thumbnailEncryption)
   return {
        coverImage: coverImage,
        setImagesJson: response.entities[0].assetIdList,
        isShared,
        singleAlbumContext: constructSingleAlbumViewInfo(response,coverImage)
    }    
    
}
